import { render, staticRenderFns } from "./TrashTable.vue?vue&type=template&id=2203ca26&scoped=true&"
import script from "./TrashTable.vue?vue&type=script&lang=js&"
export * from "./TrashTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203ca26",
  null
  
)

export default component.exports